<template>
  <div>
    <AtomicUiButton
      variant="primary"
      :expanded="true"
      class="margin-top-m"
      :disabled="inValidGiftCardAmount || !giftCardAmount"
      :loading="isAddToBagLoading"
      @click="handleAddToBag"
    >
      {{ giftCardSlideOut.myGiftsDetailsATB }}
    </AtomicUiButton>
  </div>
</template>

<script setup>
import { giftCardSlideOut } from 'config';
import { useGiftCard } from '~/composables/useGiftCard';

const props = defineProps({
  product: {
    type: Object,
    required: false,
  },
  isRegistrant: {
    type: Boolean,
    required: false,
    default: false,
  },
  slideoutId: {
    type: String,
    required: true,
  },
  eGiftEnabled: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(['registry-atb-error', 'refresh-atb']);

const { handleAddToBag, giftCardAmount, inValidGiftCardAmount, isAddToBagLoading } = useGiftCard({
  propProduct: props.product,
  propSlideoutId: props.slideoutId,
  propIsRegistrant: props.isRegistrant,
  eGiftEnabled: props.eGiftEnabled,
  emits,
});
</script>
